import Vue from 'vue'
import moment from 'moment'
moment.locale('tr')
Vue.prototype.$moment = moment

export default moment